export const breadcrumb = {
  dashboard: 'Дашборд',
  profile: 'Профиль',
  logout: 'Выход',
  document: {
    index: 'Документы',
    create: 'Добавить документ'
  },
  payment: {
    index: 'Платежи'
  },
  price: {
    index: 'Тарифы'
  }
};
